import {Injectable} from '@angular/core';
import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {
  StatusEventSignalValueParsingType
} from '@constants/machine/status-event-signal/status-event-signal-value-parsing-type.enum';

@Injectable({
  providedIn: 'root'
})
export class StatusEventSignalConvertService {

  public convertStatusEventSignalEventsDetailsToObject(details: StatusEventSignalEventsDetails | null) {
    const resultDetails: any = {};

    if (!details) {
      return resultDetails;
    }

    if (details.definitions && details.definitions.size > 0) {
      details.definitions.forEach((item, key) => {
        resultDetails[key] = {
          code: item.code,
          type: item.type,
          description: item.description,
          metadata: this.parseMapToObject(item.metadata),
          localizations: this.parseMapToObject(item.localizations)
        };
      });
    }
    return {
      id: details.id,
      name: details.name,
      label: details.label,
      unit: details.unit,
      parsingType: details.parsingType,
      machineId: details.machineId,
      csvMappingDisabled: details.csvMappingDisabled,
      definitions: resultDetails
    };

  }

  public convertObjectToStatusEventSignalEventsDetails(object: any):StatusEventSignalEventsDetails {
    const id: number = object.id;
    const name: string = object.name;
    const label: string = object.label;
    const unit: string = object.unit;
    const machineId: number = object.machineId;
    const parsingType: StatusEventSignalValueParsingType = object.parsingType;
    const csvMappingDisabled: boolean = object.csvMappingDisabled;

    const definitions: Map<string, StatusEventDetails> = new Map<string, StatusEventDetails>();
    if (object.definitions) {
      const objectKeys = Object.keys(object.definitions);
      for (const key of objectKeys) {

        const entry = object.definitions[key];
        const eventDetails = new StatusEventDetails(entry.code, entry.type, entry.description,
            this.parseObjectToMap(entry.metadata), this.parseObjectToMap(entry.localizations));
        definitions.set(key, eventDetails);

      }
    }

    const result: StatusEventSignalEventsDetails = new StatusEventSignalEventsDetails(id, name, label, unit, parsingType, definitions, machineId);
    result.csvMappingDisabled = csvMappingDisabled;

    return result;
  }

  private parseObjectToMap(object: any): Map<string, string> {
    const result: Map<string, string> = new Map<string, string>();
    const objectKeys = Object.keys(object);
    for (const key of objectKeys) {
      result.set(key, object[key]);
    }

    return result;

  }

  private parseMapToObject(map: Map<string, string>) {
    const result = {};
    map.forEach((item, key) => {
      result[key] = item;
    });
    return result;
  }
}
